import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import './CustomModal.css';


function UploadModal( props) {

    const [isUploading, setIsUploading] = React.useState(false);

    const handleUpload = async () => {
        setIsUploading(true);
        try {
            await props.onUpload();
        } finally {
            setIsUploading(false);
            props.onHide(); // Move this here to ensure it only runs after upload completes
        }
    };

    const guardedHide = () => {
        if (!isUploading) props.onHide();
    };

    return (
        <Modal
            show={props.show}
            backdrop={isUploading ? "static" : true}  // block backdrop clicks during upload
            keyboard={!isUploading}                   // block ESC during upload
            onHide={guardedHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                </Modal.Title>
            </Modal.Header>
            <h2 className='modal-heading'>Do you want to upload this custom quote?</h2>
            {props.fileName ? (<Button disabled variant='link'>{props.fileName}</Button>) : undefined}
            <Modal.Footer style={{ marginTop: '10px' }}>
                <Button variant="outline-success" onClick={props.onHide} disabled={isUploading}>No, cancel</Button>
                <Button variant="success" onClick={handleUpload} disabled={isUploading}>
                    {isUploading ? 'Uploading...' : 'Yes, upload'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadModal;